<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>كشف تحصيل</h1>
                    </div>
                    <ul>[
                      <li style="display: inline;" v-for="item in this.mainData.itineraries" :key="item.id">
                        {{ item.name }} -
                      </li>
                    ]</ul>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div style=" height: 40px;" class='panel-heading'>
                              <div class='col-lg-4 col-md-4 col-sm-6'>
                                  <label>المحصل:</label>
                                  {{this.mainData.collector_name}}
                               </div>
                               <div class='col-lg-4 col-md-4 col-sm-6'>
                                   <label>من:</label>
                                   {{this.mainData.date_even}}
                                </div>
                                <div class='col-lg-4 col-md-4 col-sm-6'>
                                    <label>الى:</label>
                                    {{this.mainData.date_to}}
                                 </div>
                               </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>
                                        <th style='padding:2px;text-align: center'>م</th>
                                        <th style='padding:2px;text-align: center'>السجل</th>
                                        <th style='padding:2px;text-align: center'>الاسم</th>
                                        <th style='padding:2px;text-align: center'>اسم الشهرة</th>
                                        <th style='padding:2px;text-align: center'>المحافظة</th>
                                        <th style='padding:2px;text-align: center'>المدينة</th>
                                        <th style='padding:2px;text-align: center'>الخط</th>
                                        <th style='padding:2px;text-align: center'>المحمول</th>
                                        <th style='padding:2px;text-align: center'>المبلغ</th>
                                        <th style='padding:2px;text-align: center'>التاريخ</th>
                                        <th style='padding:2px;text-align: center'>الايصال</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='(record,index) in records' :key='record.id'>

                                           <td align='center'>{{index +1 }}</td>
                                           <td align='center'>{{record.rec_id}}</td>
                                           <td align='center'>{{record.name}}</td>
                                           <td align='center'>{{record.nickname}}</td>
                                          <td align='center'>{{record.gov}}</td>
                                          <td align='center'>{{record.city}}</td>
                                          <td align='center'>{{record.itiname}}</td>
                                          <td align='center'>{{record.mobile}}</td>
                                          <td align='center'>{{record.amount}}</td>
                                          <td align='center'>{{record.due_date}}</td>
                                          <td align='center'>{{record.code}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'CollectingSheet',
  data () {
    return {
      validationErrors: '',
      records: {},
      record: {},
      mainData: {},
      isLoadingData: false
    }
  },
  created () {
    this.GetData()
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getCollectingSheet', {
        token: localStorage.getItem('token'),
        collector_id: this.$route.params.collector_id,
        date_even: this.$route.params.date_even,
        date_to: this.$route.params.date_to
      })
        .then(({ data }) => {
          this.records = data.data
          this.mainData = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/CollectingSheet.vue